import HtmlUtils from "../../../components/HtmlUtils.js";

export default class TwoButtonsDialog {
    constructor() {
        this._dialog = null;
        this._callbacks = [];
    }

    /**
     * @param {string} eventName
     * @param {function} callback
     */
    on(eventName, callback){
        this._callbacks[eventName] = callback;
    }

    /**
     * @param {string} html
     * @param {string} cssClassName
     * @returns {TwoButtonsDialog}
     */
    render(html, cssClassName) {
        if (this._dialog)
            this._dialog.remove();
        this._dialog = this._createModal(TwoButtonsDialog._htmlTemplate(html, cssClassName));

        let cancelBtn = this._dialog.querySelector('.btn-cancel');
        cancelBtn.addEventListener('click', ()=>{
            this.remove();
            if (this._callbacks['cancel']) this._callbacks['cancel']();
        })

        let okBtn = this._dialog.querySelector('.btn-ok');
        okBtn.addEventListener('click', ()=>{
            this._dialog.querySelector('.progress').style.display = 'block';
            okBtn.setAttribute('disabled', true);
            if (this._callbacks['ok']) this._callbacks['ok']();
            this.remove();
        });

        this._dialog.addEventListener('keydown', (evt) => {
            evt.stopPropagation();
            if (evt.repeat) return;
            switch (evt.key) {
                case 'Enter' : {
                    if (!okBtn.getAttribute('disabled') === true)
                        okBtn.dispatchEvent(new Event('click'))
                    break;
                }
                case 'Escape' :
                    cancelBtn.dispatchEvent(new Event('click'))
            }
        })
        this._dialog.focus();

        return this;
    }

    remove() {
        this._dialog.remove();
    }

    _createModal(node) {
        return HtmlUtils.createModal(node);
    }

    /**
     * @param {string} html
     * @param {string} cssClassName
     * @returns {Node}
     * @private
     */
    static _htmlTemplate(html, cssClassName = "") {
        let tmpl = document.createElement('template');
        tmpl.innerHTML = `
            <div id="two-buttons-dialog" class="dialog ${cssClassName}">
              <div class="progress">
                <div class="indeterminate"></div>
              </div>
              <div class="dialog-content">
                ${html}
              </div>
              <div class="dialog-buttons-row">
                <button class="button button--text btn-cancel">Cancel</button>
                <button class="button button--contained btn-ok">Ok</button>
              </div>
            </div>`
        ;
        return tmpl.content.cloneNode(true);
    }
}
